// updating to use new 4i dialog
$(function(){	
	var myPlayer;
	var origFocus;
	$(document).on('click', ".videoLink", function(e){
		e.preventDefault();
		
		var productVideoDialog = dialog4i();
		productVideoDialog.init(document.getElementById('videoDialog'));
		
		var vidTitle = $(this).attr("title");
		$("#videoDialog").find("h2").html("<label for='azuremediaplayer_AzureHtml5JS_api'>" + vidTitle + "</label>");

		productVideoDialog.open();
		
		var controllerUrl = "/video/videodetails/" + $(this).attr("data-productid");
		var videoUrl;		
		origFocus = $(this);
		
		$.get(controllerUrl, function(data){
			videoUrl = data.PublishedUrl;					
			var vidMarkup = "<video id=\"azuremediaplayer\" class=\"azuremediaplayer amp-flush-skin amp-big-play-centered embed-responsive-item\" width=\"100%\" height=\"100%\" tabindex=\"0\">" + "</video>";
                	$("#videoContainer").html(vidMarkup);
                	
			//initialize the player
			myPlayer = amp('azuremediaplayer', {
				autoplay: true,
				controls: true,
				logo: { enabled: false },
				techOrder: ["azureHtml5JS", "flashSS", "html5FairPlayHLS", "silverlightSS", "html5"]
			});
			
			// Add subtitles, if available
			if(data.EnglishSubtitleUrl && data.EnglishSubtitleUrl.length > 0) {
				myPlayer.src(
					[{ src: videoUrl, type: "application/vnd.ms-sstr+xml" }],
					[{ src: data.EnglishSubtitleUrl, srclang: "en", kind: "subtitles", label: "English" }]
				);
			} else {
				myPlayer.src(
					[{ src: videoUrl, type: "application/vnd.ms-sstr+xml" }]
				);	
			}
		});
	});
	// if dialog is closed, dispose of player so it is removed when reloading dialog
	$("#videoDialog .close4iDialog").on("click", function(e){
		e.preventDefault();
		closeVideoDialog();
	});
	$("#videoDialog").on("keydown", function(e){
		if(e.keyCode === 27) /*esc*/{
			closeVideoDialog();
		}
	});
	var closeVideoDialog = function(){
		myPlayer.dispose();
		origFocus.focus();
	};
});